var _path, _path2, _path3, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgViewBackground(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9426 1.25H12.0574C14.3658 1.24999 16.1748 1.24998 17.5863 1.43975C19.031 1.63399 20.1711 2.03933 21.0659 2.93414C21.9607 3.82895 22.366 4.96897 22.5603 6.41371C22.75 7.82519 22.75 9.63423 22.75 11.9426V12.0574C22.75 14.3658 22.75 16.1748 22.5603 17.5863C22.366 19.031 21.9607 20.1711 21.0659 21.0659C20.1711 21.9607 19.031 22.366 17.5863 22.5603C16.1748 22.75 14.3658 22.75 12.0574 22.75H11.9426C9.63423 22.75 7.82519 22.75 6.41371 22.5603C4.96897 22.366 3.82895 21.9607 2.93414 21.0659C2.03933 20.1711 1.63399 19.031 1.43975 17.5863C1.24998 16.1748 1.24999 14.3658 1.25 12.0574V11.9426C1.24999 9.63423 1.24998 7.82519 1.43975 6.41371C1.63399 4.96897 2.03933 3.82895 2.93414 2.93414C3.82895 2.03933 4.96897 1.63399 6.41371 1.43975C7.82519 1.24998 9.63423 1.24999 11.9426 1.25ZM6.61358 2.92637C5.33517 3.09825 4.56445 3.42514 3.9948 3.9948C3.42514 4.56445 3.09825 5.33517 2.92637 6.61358C2.75159 7.91356 2.75 9.62178 2.75 12C2.75 14.3782 2.75159 16.0864 2.92637 17.3864C3.09825 18.6648 3.42514 19.4355 3.9948 20.0052C4.56445 20.5749 5.33517 20.9018 6.61358 21.0736C7.91356 21.2484 9.62178 21.25 12 21.25C14.3782 21.25 16.0864 21.2484 17.3864 21.0736C18.6648 20.9018 19.4355 20.5749 20.0052 20.0052C20.5749 19.4355 20.9018 18.6648 21.0736 17.3864C21.2484 16.0864 21.25 14.3782 21.25 12C21.25 9.62178 21.2484 7.91356 21.0736 6.61358C20.9018 5.33517 20.5749 4.56445 20.0052 3.9948C19.4355 3.42514 18.6648 3.09825 17.3864 2.92637C16.0864 2.75159 14.3782 2.75 12 2.75C9.62178 2.75 7.91356 2.75159 6.61358 2.92637Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6 12C6 10.5858 6 9.87868 6.43934 9.43934C6.87868 9 7.58579 9 9 9H15C16.4142 9 17.1213 9 17.5607 9.43934C18 9.87868 18 10.5858 18 12V16C18 17.4142 18 18.1213 17.5607 18.5607C17.1213 19 16.4142 19 15 19H9C7.58579 19 6.87868 19 6.43934 18.5607C6 18.1213 6 17.4142 6 16V12Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7 5.25C6.58579 5.25 6.25 5.58579 6.25 6C6.25 6.41421 6.58579 6.75 7 6.75H12C12.4142 6.75 12.75 6.41421 12.75 6C12.75 5.58579 12.4142 5.25 12 5.25H7Z",
    fill: "black"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_11_4654)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.157 1.96115H1.9675V23.2215H23.157V1.96115Z",
    fill: "#DFDDD0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5377 16.2148C17.4265 16.2148 18.147 15.4919 18.147 14.6001C18.147 13.7083 17.4265 12.9854 16.5377 12.9854C15.6489 12.9854 14.9284 13.7083 14.9284 14.6001C14.9284 15.4919 15.6489 16.2148 16.5377 16.2148Z",
    fill: "#F5BA51"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.85257 23.2215H17.8118L11.1828 13.2449C10.541 12.2741 9.11371 12.2741 8.4719 13.2449L1.85257 23.2215Z",
    fill: "#3A8382"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.8842 23.2215H22.4098L18.8751 17.8968C18.5302 17.3778 17.7734 17.3778 17.4286 17.8968L13.8938 23.2215H13.8842Z",
    fill: "#4DA3A3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.2411 24H3.75885C2.23574 24 1 22.7601 1 21.2415V3.75846C1 2.23987 2.23574 1 3.75885 1H21.2411C22.7643 1 24 2.23987 24 3.75846V21.2415C24 22.7601 22.7643 24 21.2411 24ZM3.75885 1.96114C2.77218 1.96114 1.96751 2.76849 1.96751 3.75846V21.2415C1.96751 22.2315 2.77218 23.0389 3.75885 23.0389H21.2411C22.2278 23.0389 23.0325 22.2315 23.0325 21.2415V3.75846C23.0325 2.76849 22.2278 1.96114 21.2411 1.96114H3.75885Z",
    fill: "#414042"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.4927 4.87338H1.9675V7.77602H5.4927V4.87338Z",
    fill: "#414042"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.00832 1.96115H5.48312V4.86378H9.00832V1.96115Z",
    fill: "#414042"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5335 4.87338H9.00833V7.77602H12.5335V4.87338Z",
    fill: "#414042"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0587 1.96115H12.5335V4.86378H16.0587V1.96115Z",
    fill: "#414042"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.5839 4.87338H16.0587V7.77602H19.5839V4.87338Z",
    fill: "#414042"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.0995 1.96115H19.5743V4.86378H23.0995V1.96115Z",
    fill: "#414042"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.00832 7.776H5.48312V10.6786H9.00832V7.776Z",
    fill: "#414042"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0587 7.776H12.5335V10.6786H16.0587V7.776Z",
    fill: "#414042"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.0995 7.776H19.5743V10.6786H23.0995V7.776Z",
    fill: "#414042"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.0325 10.5825H1.9675V10.8516H23.0325V10.5825Z",
    fill: "#414042"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_11_4654"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 23,
    height: 23,
    fill: "white",
    transform: "translate(1 1)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgViewBackground);
export default __webpack_public_path__ + "static/media/view-background.d6cdba1c4c635e3be879ce114b664cd1.svg";
export { ForwardRef as ReactComponent };